<template>
    <div class="container kanit">
      <div v-if="stepOTP.first" class="first-step">
        <div class="d-flex mt-3 justify-content-end align-items-center">
            <span class="text-line-primary">ขั้นตอนที่ 1</span><span class="text-muted">/3</span>
        </div>
        <div class="d-flex">
            <div class="col-3 align-self-start">
                <img :src="profileUser.picture" class="profile-image rounded-circle w-100">
            </div>
            <div class="col-9 p-0">
                <h1 class="font-header-register">ลงทะเบียนใช้งาน</h1>
                <h2 class="font-welcome">สวัสดีคุณ <span class="text-line-primary">{{ profileUser.name ? profileUser.name : '' }}</span></h2>
            </div>
        </div>
        <div class="mt-4">
            <label for="phone">เบอร์โทรศัพท์</label>
            <b-input-group>
              <b-input-group-prepend>
                <span class="input-group-text" :class="{ 'is-invalid-fail': $v.phoneNumber.$error }">
                  <img :src="iconPhone.url" alt="">
                </span>
              </b-input-group-prepend>
              <b-form-input ref="inputTel" type="tel" placeholder="เบอร์โทรศัพท์ 10 หลัก" v-model="formattedPhoneNumber" @keyup="formatPhoneNumber" maxlength="10" :class="{ 'is-invalid': $v.phoneNumber.$error }" autofocus/>
            </b-input-group>
            <b-button class="mg-custom-nextstep" block type="submit" variant="line-primary" @click="sendPhoneOTP">ดำเนินการต่อ</b-button>
        </div>
      </div> 
      <div v-if="stepOTP.second" class="secound-step">
        <div class="d-flex mt-3 justify-content-end align-items-center">
            <span class="text-line-primary">ขั้นตอนที่ 2</span><span class="text-muted">/3</span>
        </div>
        <div class="d-flex">
            <div class="col-12">
                <div class="d-flex flex-column justify-content-start">
                    <h1>
                        ยืนยันเบอร์โทรศัพท์
                    </h1>
                    <h2 class="message-sendOTP">
                        กรุณาใส่รหัสยืนยันตัวตนที่ถูกส่งไปยัง
                    </h2>
                    <p>
                        <span class="message-sendOTP">หมายเลข</span> <span class="numberOTP-fix">{{ '******' + phoneNumber.slice(6) }} (Ref: {{ ref_code }})</span>
                    </p>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center">
                    <form method="get" class="digit-group" data-group-name="digits" data-autosubmit="false" autocomplete="off">
                        <input type="tel" v-model="inputOTP.a"
                            class="color-otp"
                            @keyup="focusInput($event,null,'a','b')"
                            @paste="handlePasteOTP($event, 'a')"
                            ref="a"
                            min="0" 
                            max="9" 
                            maxlength="1"
                            autocomplete="one-time-code"
                            />
                        <input type="tel" v-model="inputOTP.b"
                            class="color-otp"
                            @keyup="focusInput($event,'a','b','c')"
                            @paste="handlePasteOTP($event, 'b')"
                            ref="b"                    
                            min="0" 
                            max="9" 
                            maxlength="1"
                            autocomplete="one-time-code"
                            />
                        <input type="tel" v-model="inputOTP.c"
                            class="color-otp"
                            @keyup="focusInput($event,'b','c','d')"
                            @paste="handlePasteOTP($event, 'c')"
                            ref="c"                   
                            min="0" 
                            max="9" 
                            maxlength="1"
                            autocomplete="one-time-code"
                            />
                        <input type="tel" v-model="inputOTP.d"
                            class="color-otp"
                            @keyup="focusInput($event,'c','d',null)"
                            @paste="handlePasteOTP($event, 'd')"
                            ref="d"                   
                            min="0" 
                            max="9" 
                            maxlength="1"
                            autocomplete="one-time-code"
                            />
                    </form>
                    <p v-if="errorOTP.fail" class="text-line-danger pd-tb-16px">รหัสยืนยันไม่ถูกต้อง</p>
                    <p v-else-if="errorOTP.expired" class="text-line-danger pd-tb-16px">รหัสยืนยันหมดอายุ กรุณากดส่งรหัสอีกครั้ง</p>

                    <p v-if="timer > 0" class="text-muted"><span class="ml-3">{{ timer }} วินาที</span></p>
                    <p v-else class="cursor-pointer text-line-primary" @click="sendReturnOTP"><i class="fas fa-redo"></i><span class="ml-3">ส่งรหัสอีกครั้ง</span></p>
                </div>
            </div>
        </div>
      </div> 
    </div>
  </template>
  
  <script>
  import { required, minLength, numeric } from "vuelidate/lib/validators";

  const context_line = JSON.parse(localStorage.getItem('context_line'))
  export default {
    metaInfo: {
      title: 'ลงทะเบียนเว็บไซต์',
    },
    data() {
        return {
          stepOTP: {
            first: true,
            second: false,
          },
          profileUser: {
              name: '',
              picture: ''
          },
          mainProps: { blank: true, blankColor: '#777', width: '60', height: '73', class: 'm1' },
          imageUrl: 'https://via.placeholder.com/150',
          phoneNumber: '',
          maskPhone: '',
          digits: ['', '', '', ''],
          inputOTP: {
            a: '',
            b: '',
            c: '',
            d: ''
          },
          maxLength: 1,
          code: '000000',
          timer: 0,
          ref_code: '',
          errorOTP: {
            fail: false,
            expired: false
          },
          iconPhone: {
            url: require("../../assets/icon/phone.svg")
          }
        }
    },
    validations: {
      phoneNumber:  { 
        required,
        minLength: minLength(10),
        numeric
      }
    },
    async mounted() {
      this.$liff.init({
        liffId: context_line.liffId
      })
      this.$refs.inputTel.focus();
      const getProfile = JSON.parse(localStorage.getItem('profile_line'))
      this.profileUser.name = getProfile.name
      this.profileUser.picture = getProfile.picture ? getProfile.picture : ''
      this.isRegister();
    },
    computed: {
        formattedPhoneNumber: {
          get() {
            return this.maskPhone;
          },
          set(newValue) {
            console.log('newValue:', newValue);
            this.phoneNumber = newValue.replace(/[^0-9]/g, '');
            this.maskPhone = newValue
          }
        }
    },
      methods: {
        focusInput(event,beforeInput, currentInput, nextInput) {
          const OTPPattern = /[0-9]+/ig;
          if (event.target.value && event.target.value.length > 4) {
            return;
          }else if (event.target.value.length === 4) {
            return this.handlePasteOTP(event.target.value, 'a')
          }
          if (
            event.keyCode === 8 || // backspace
            event.keyCode === 37 // left arrow
          ) {
            this.$refs[beforeInput].focus();
          } else if (
            OTPPattern.test(event.target.value) ||
            event.keyCode === 39 // right arrow
          ) {
            if (typeof this.inputOTP.a !== 'undefined' && this.inputOTP.a !== '' &&
                typeof this.inputOTP.b !== 'undefined' && this.inputOTP.b !== '' &&
                typeof this.inputOTP.c !== 'undefined' && this.inputOTP.c !== '' &&
                typeof this.inputOTP.d !== 'undefined' && this.inputOTP.d !== '') {
              const otpConcat = this.inputOTP.a + this.inputOTP.b + this.inputOTP.c + this.inputOTP.d
              this.verifyOTP(otpConcat)
            }
            this.$refs[nextInput].focus();
          }
          
        },
        async isRegister() {
          const getProfile = JSON.parse(localStorage.getItem('profile_line'))
          let status
          await this.$http.get(this.$API_URL + `/line/isregister/shop/${getProfile.sub}`).then((res) => {
            status = res.data.status
          })
          if (status) {
            return true;
          }
          this.$router.push('/location/timeout')
        },
        sendOTPverify(phoneNumber) {
          if (this.timer > 0) return;
          return new Promise((resolve, reject) => {
            this.$http.post(this.$API_URL + '/v2/tracking/request/otp', {
              tel: phoneNumber
            }).then((res)=> {
              this.timer = 60;
              let intervalId = setInterval(() => {
                if(this.timer > 0) {
                    this.timer--;
                }
                if(this.timer === 0) {
                    clearInterval(intervalId);
                    return;
                }
              }, 1000);
              resolve(res.data)
            }, (err) => {
              reject(err)
            });
          });
        },
        sendPhoneOTP() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                console.log('invalid phone')
                return false
            }
            this.sendOTPverify(this.phoneNumber).then((response) => {
              if (response.status) {
                this.ref_code = response.data.ref_code;
                this.stepOTP.first = false
                this.stepOTP.second = true
              } else {
                // alert something wrong
                if (response.error) {
                  alert(response.error.message)
                } else {
                  alert('กรุณาติดต่อเจ้าหน้าที่')
                }
              }
            }, (err)=> {
              alert('something error');
            });
        },
        sendReturnOTP() {
            this.digits = ['', '', '', '']
            this.sendOTPverify(this.phoneNumber).then((response) => {
              if (response.status) {
                this.ref_code = response.data.ref_code;
              } else {
                // alert something wrong
                if (response.error) {
                  alert(response.error.message)
                } else {
                  alert('กรุณาติดต่อเจ้าหน้าที่')
                }
              }
            }, (err)=> {
              alert('something error');
            });
        },
        async handlePasteOTP (event, currentInput) {
          const patternPasteOTP = /[0-9]+/ig;
          let OTPMessage = event.clipboardData.getData('text').toString();
          if(OTPMessage.length > 4) {
            return
          }
          if(patternPasteOTP.test(OTPMessage)) {
            this.inputOTP.a = OTPMessage.split('')[0]
            this.inputOTP.b = OTPMessage.split('')[1]
            this.inputOTP.c = OTPMessage.split('')[2]
            this.inputOTP.d = OTPMessage.split('')[3]
            if(currentInput === 'a') {
              this.inputOTP.a = OTPMessage.split('')[0]
            }else if(currentInput === 'b') {
              this.inputOTP.b = OTPMessage.split('')[1]
            }else if(currentInput === 'c'){
              this.inputOTP.c = OTPMessage.split('')[2]
            }else if(currentInput === 'c') {
              this.inputOTP.d = OTPMessage.split('')[3]
            }
          }
          if(OTPMessage.length === 4) {
            const otpConcat = this.inputOTP.a + this.inputOTP.b + this.inputOTP.c + this.inputOTP.d
            this.verifyOTP(otpConcat)
          }
        },
        verifyOTP(value) {
          const body = {
            tel: this.phoneNumber,
            ref_code: this.ref_code,
            otp: value
          }
          this.$http.post(this.$API_URL + '/v2/tracking/verify-otp', body).then((res)=> {
            const status = res.data.status
            if(status) {
              const setString = '?phoneNumber=' + this.phoneNumber
              const sendqueryParam = encodeURIComponent(setString)
              const accessToken = localStorage.getItem('access_token_line')
              this.switchLiff(accessToken, sendqueryParam, 'FULL')
            }else {
              if(res.data.error.code === 'EXPIRED_OTP') {
                this.errorOTP.expired = true
                this.inputOTP.a = ''
                this.inputOTP.b = ''
                this.inputOTP.c = ''
                this.inputOTP.d = ''
              }else {
                this.errorOTP.fail = true
                this.inputOTP.a = ''
                this.inputOTP.b = ''
                this.inputOTP.c = ''
                this.inputOTP.d = ''
              }
            }
            
          })
        },
        switchLiff(access_token, queryparam, size) {
          const bodyrequest = {
            access_token: access_token,
            temp_liff_id: context_line.liffId,
            size: size
          }
          this.$http.post(this.$API_URL + `/line/switch/size/${context_line.liffId}`, bodyrequest).then(async (res) => {
            const status = res.data.status
            console.log('data response call switch size: ', res.data)
            if(status) {
                const response = res.data.data
                const liffIdSwitch = response.line_liff_id
                console.log('liffIdSwitch: ', liffIdSwitch)
                const queryParamsend = queryparam ? `&queryparams=${queryparam}` : ''
                const urllog = `https://liff.line.me/${liffIdSwitch}?liffId=${liffIdSwitch}&redirectPath=registerpage`+queryParamsend
                console.log('url log: ', urllog)
                this.$liff.openWindow({
                  url: `https://liff.line.me/${liffIdSwitch}?liffId=${liffIdSwitch}&redirectPath=registerpage`+queryParamsend,
                  external: false,
                })
            }
          })
        },
        getLiffStateValue () {
            const url = new URL(window.location.href);        
            const liffState = url.searchParams.get("liff.state");            
            const urlParams = new URLSearchParams(liffState);
            const liffId = urlParams.get('liffId');
            const userId = urlParams.get('userId');
            const redirectPath = urlParams.get('redirectPath');
            const keyObj = { liffId, userId, redirectPath }
            return keyObj;
        },
        formatPhoneNumber(event) {
          if (event.keyCode === 8 || event.target.value.replace(/-/g, '').length <=9) {          
              this.formattedPhoneNumber = this.formattedPhoneNumber.replace(/-/g, '')            
            }else {
              this.formattedPhoneNumber = this.formattedPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            }
        },
        updateCode(index, value) {
            let newCode = this.code.split('');
            newCode[index] = value;
            this.code = newCode.join('');
        }
      },
      watch:{
        'inputOTP.a': {
            handler(newVal, oldValue){
              console.log('a: newVal: ', newVal)
              console.log('a: oldValue: ', oldValue)
              if(newVal.split('').length === 4) {
                this.inputOTP.a = newVal.split('')[0]
              }else {
                this.inputOTP.a = newVal.split('')[newVal.split('').length-1];
                if(oldValue.split('').length >= 4) {
                  this.inputOTP.a = oldValue.split('')[1]
                }
              }
            },
            deep: true
        },
        'inputOTP.b': {
            handler(newVal, oldValue){
              if(newVal.split('').length === 4) {
                this.inputOTP.b = newVal.split('')[1]
              }else {
                this.inputOTP.b = newVal.split('')[newVal.split('').length-1];
                if(oldValue.split('').length >= 4) {
                  this.inputOTP.b = oldValue.split('')[2]
                }
              }
            },
            deep: true
        },
        'inputOTP.c': {
            handler(newVal, oldValue){
              console.log('c: newVal: ', newVal)
              console.log('c: oldValue: ', oldValue)
              if(newVal.split('').length === 4) {
                this.inputOTP.c = newVal.split('')[2]
              }else {
                this.inputOTP.c = newVal.split('')[newVal.split('').length-1]
                if(oldValue.split('').length >= 4) {
                  this.inputOTP.c = oldValue.split('')[3]
                }
              }
            },
            deep: true
        },
        'inputOTP.d': {
            handler(newVal, oldValue){
              if(newVal.split('').length === 4) {
                this.inputOTP.d = newVal.split('')[3]
              }else {
                this.inputOTP.d = newVal.split('')[newVal.split('').length-1];
                if(oldValue.split('').length >= 4) {
                  this.inputOTP.d = oldValue.split('')[4]
                }
              }
            },
            deep: true
        }
      }
  }
  </script>
